require('jscroll');

$('.slick-webtv-container').slick({
    dots: true,
    infinite: true,
});
$('.webtv-grid-container .grid').jscroll({
    loadingHtml: '<b class="loading-text">Henter...</b>',
    autoTrigger: false,
    nextSelector: '.load-videos',
    contentSelector: '.grid > div'
});

